import {Component} from '@angular/core';
import {dashboardColumns} from '@shared/columns/dashboard.columns';
import {HeaderService} from '@app/core/services/header.service';
import {ModalService} from '@app/core/services/modal.service';
import {ServiceRequestCode, ServiceRequestService, UserResponse} from '@app/api/dmc';
import {dashboardActionMenu} from '@views/dashboard/list-views/util/dashboard.action-menu';
import {TableComponent} from '@shared/components/table/table.component';
import {HeaderComponent} from '@shared/components/header/header.component';
import {dashboardCompleteModal, dashboardReplyModal} from '@views/dashboard/list-views/util/dashboard-modals.util';
import {TableConfig} from '@shared/interfaces/table/table-config';

@Component({
  selector: 'app-dashboard-servicerequest',
  imports: [
    TableComponent,
    HeaderComponent
  ],
  templateUrl: './dashboard-servicerequest.component.html',
  styleUrl: './dashboard-servicerequest.component.css'
})
export class DashboardServicerequestComponent {
  /** Table **/
  public tableConfig: TableConfig<any> = {
    id: 'table-dashboard-service-metercheck',
    exportable: true,
    columns: dashboardColumns,
    activeColumns: ['serviceType', 'meteringPointIdentification', 'pipelineType', 'createdTS', 'completionTS', 'createdBy', 'userResponse', 'actionResponse', 'isCancelledBySupplier', 'reasonText'],
    reorder: true,
    columnSelection: true,
    selectable: true,
    selectableType: 'single',
  }

  public tableData: any[] = [];

  public selectedElements: any[] = [];


  constructor(
    private readonly headerService: HeaderService,
    private readonly serviceRequestService: ServiceRequestService,
    private readonly modalService: ModalService,
  ) {
    this.headerService.setTitle('dashboard.servicerequest.title');

    this.headerService.setActions([dashboardActionMenu[0], dashboardActionMenu[1]],
      {
        complete: () => this.openCompleteModal(),
        reply: () => this.openReplyModal(),
      },
      {
        complete: () => this.selectedElements.length !== 1,
        reply: () => this.selectedElements.length !== 1,
      })

    /** Fetch Data **/
    this.fetchData()
  }

  public openReplyModal(): void {
    const el = this.selectedElements[0];
    if (!el) {
      return;
    }

    this.modalService.show({
      ...dashboardReplyModal,
      params: {
        element: el
      }
    }).subscribe(() => {
      this.fetchData()
    })
  }

  public openCompleteModal(): void {
    const el = this.selectedElements[0];
    if (!el) {
      return;
    }
    type ActionType = 'disconnect' | 'reconnect' | 'closeDown' | 'serviceRequestAction';
    let actionType: ActionType | undefined = (el.actionType as ActionType) ?? undefined;

    if (!actionType && el.serviceType) {
      switch (el.serviceType as ServiceRequestCode) {
        case ServiceRequestCode.FlexChange:
          actionType = 'reconnect';
          break;
        case ServiceRequestCode.NonProfiledChange:
          actionType = 'closeDown';
          break;
        case ServiceRequestCode.MeterCheck:
        case ServiceRequestCode.ReadingRequest:
        default:
          actionType = 'serviceRequestAction';
          break;
      }
    }

    actionType = actionType ?? 'serviceRequestAction';

    this.modalService.show({
      ...dashboardCompleteModal,
      params: {
        element: el,
        actionType
      }
    }).subscribe(() => {
      this.fetchData();
    });
  }

  /** Loops over the necessary ServiceRequest **/
  public fetchData(): void {
    this.tableData = [];

    /** Service Requests **/
    const serviceRequests: ServiceRequestCode[] = [ServiceRequestCode.MeterCheck, ServiceRequestCode.ReadingRequest, ServiceRequestCode.FlexChange, ServiceRequestCode.NonProfiledChange];

    serviceRequests.forEach((serviceRequestCode: ServiceRequestCode) => {
      this.serviceRequestService.serviceRequestQueryServiceRequestsPost({
        response: UserResponse.Required,
        serviceRequestCode: serviceRequestCode,
      }).subscribe((result: any) => {
        // Add the serviceType property to each item in the results
        const results = (result.results || []).map((item: any) => {
          const rawFlag = (item.isCancelledBySupplier ?? item.is_cancelled_by_supplier);
          let isCancelled: boolean | undefined = undefined;
          if (typeof rawFlag === 'boolean') {
            isCancelled = rawFlag;
          } else if (rawFlag !== undefined && rawFlag !== null) {
            isCancelled = rawFlag === 1 || rawFlag === '1' || String(rawFlag).toLowerCase() === 'true';
          }

          return {
            ...item,
            serviceType: serviceRequestCode,
            isCancelledBySupplier: isCancelled ?? false,
          };
        });

        this.tableData = this.tableData.concat(results);
      })
    })
  }
}
